import React from "react";
import { DirectorySort } from "@common/constants/counterparty";
import { RegisteredCounterpartyIncludeScope } from "@common/helpers/counterparties";
import { useCounterpartiesQuery } from "@api/counterparty.api";
import {
    HAS_BILLABLE_CUSTOMER_LABEL,
    NO_BILLABLE_CUSTOMER_LABEL,
} from "../AggregatedFilters/CustomerFilter/lib";
import { CounterpartiesFilterLabel } from "./CounterpartiesFilterLabel";

interface Props {
    filters: {
        customerIds?: string[];
        withEmptyCustomer?: boolean;
        hasCustomer?: boolean;
    };
}

export const CustomerFilterLabel: React.FC<Props> = ({
    filters: { customerIds, withEmptyCustomer, hasCustomer },
}) => {
    const isSingleCustomerSelected = customerIds?.length === 1;
    const counterparties = useCounterpartiesQuery(
        {
            sort: DirectorySort.NAME_ASC,
            includeRegistered: RegisteredCounterpartyIncludeScope.USED,
        },
        { enabled: isSingleCustomerSelected },
    );

    if (!customerIds?.length) {
        if (hasCustomer && !withEmptyCustomer) {
            return <>{HAS_BILLABLE_CUSTOMER_LABEL}</>;
        }
        if (withEmptyCustomer && !hasCustomer) {
            return <>{NO_BILLABLE_CUSTOMER_LABEL}</>;
        }
        if (hasCustomer && withEmptyCustomer) {
            return <>{HAS_BILLABLE_CUSTOMER_LABEL}</>;
        }
    }

    return (
        <CounterpartiesFilterLabel
            filters={{
                counterpartiesIds: customerIds,
                withEmptyOrUnverifiedCounterparty: withEmptyCustomer,
                hasCounterparty: hasCustomer,
            }}
            counterparties={counterparties.data?.data}
            entityLabel="customer"
        />
    );
};
